import * as React from 'react';

import {RemoveButton} from 'shells/button/remove-button/remove-button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {colors} from 'shells/colors/colors';
import {Dialog} from 'shells/dialog/dialog';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {useDeleteEntitySummary} from '../graphql/hooks/use-delete-entity-summary';

import styles from './summary-header.module.css';

type Props = {
    entityId: string;
    entitySummaryId: string | null | undefined;
};

export function SummaryHeader(props: Props) {
    const {entityId, entitySummaryId} = props;
    const [isConfirming, setIsConfirming] = React.useState<boolean>(false);

    const removeButtonRef = React.useRef(null);

    const deleteEntitySummary = useDeleteEntitySummary(entityId, 'TIMELINE');

    const onConfirmationAccept = () => {
        if (entitySummaryId) {
            deleteEntitySummary({entitySummaryId}).catch(() => {
                setIsConfirming(false);
            });
        }
    };

    return (
        <>
            <div className={styles['summary-header']}>
                <StackLegacy spacing={4} isHorizontal={true} alignCenter={true}>
                    {/* @ts-expect-error */}
                    <AiSparkleNewIcon size={17} alignCenter={true} color={colors.company} />
                    <div className={styles['summary-header-title']}>AI Summary</div>
                </StackLegacy>
                <ButtonMover size='normal' direction={['up', 'right']}>
                    <RemoveButton
                        size={13}
                        getButtonRef={removeButtonRef}
                        onClick={() => setIsConfirming(true)}
                        isDisabled={!entitySummaryId}
                    />
                </ButtonMover>
            </div>
            {isConfirming ? (
                <Dialog
                    anchor={removeButtonRef.current}
                    question='Deleting this summary will remove it from this timeline for all people on your Nutshell account.'
                    secondaryText='No, don’t delete'
                    onSecondary={() => setIsConfirming(false)}
                    primaryText='Yes, delete'
                    primaryVariant='danger'
                    onPrimary={onConfirmationAccept}
                    onBlur={() => setIsConfirming(false)}
                />
            ) : undefined}
        </>
    );
}
